import React from 'react'

const SadIcon = ({ color = '#000', className = '' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 15.5 15.5">
      <path
        data-name="Path 930"
        d="M15 15a3.019 3.019 0 0 0-.864-1.219 3.336 3.336 0 0 0-4.252-.031A3.026 3.026 0 0 0 9 14.956"
        style={{
          strokeLinejoin: 'round',
          fill: 'none',
          stroke: color,
          strokeLinecap: 'round',
          strokeWidth: '1.5px',
        }}
        transform="translate(-4.25 -4.25)"
      />
      <path
        data-name="Path 931"
        d="M9 10V9"
        style={{ fill: 'none', stroke: color, strokeLinecap: 'round', strokeWidth: '1.5px' }}
        transform="translate(-4.25 -4.25)"
      />
      <path
        data-name="Path 932"
        d="M19 12a7 7 0 1 1-2.05-4.95A7 7 0 0 1 19 12z"
        style={{
          fillRule: 'evenodd',
          strokeLinejoin: 'round',
          fill: 'none',
          stroke: color,
          strokeLinecap: 'round',
          strokeWidth: '1.5px',
        }}
        transform="translate(-4.25 -4.25)"
      />
      <path
        data-name="Path 933"
        d="M15 10V9"
        style={{ fill: 'none', stroke: color, strokeLinecap: 'round', strokeWidth: '1.5px' }}
        transform="translate(-4.25 -4.25)"
      />
    </svg>
  )
}

export default SadIcon
